import React from 'react';
import Option from './option'
class Options extends React.Component {
  
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
      {
        this.props.options.map((option, i) =>
          <Option
            key={i}
            option={option}
          />
        )
      }
      </>
    )
  }
}

export default Options;